import "./style.css";
import React, { useEffect } from "react";

import Loader from "components/Spinners/Loader";
import { useAuthStore } from "stores/auth/authStore";
import ProfileModal from "components/Modal/Profile";
import ProfileInfo from "./ProfileInfo";

const Profile = () => {
  const isLoading = useAuthStore((state) => state.isLoading);
  const fetchFullUserProfile = useAuthStore((state) => state.fetchFullUserProfile);

  useEffect(() => {
    fetchFullUserProfile();
  }, [fetchFullUserProfile]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-[50dvh] w-full">
        <Loader
          filledColor="#2b364b"
          className="!h-[50px] !flex !items-center !text-center !justify-center"
        />
      </div>
    );
  }
  
  return (
    <>
      <ProfileInfo />
      <ProfileModal />
    </>
  );
};

export default Profile;